<template>
  <modal :title="'Send Message'" :active.sync="modals.sendMessage" size="xl">
    <shared-send-message></shared-send-message>
  </modal>
</template>

<script>

import Utils from '@/helpers/utils'
import Modal from '@/components/Modal'
import {EventBus} from '@/../eventbus'
import SharedSendMessage from '@/views/Shared/Messages/Send'

export default {
  name: 'Global.Popup.SendSms',
  components: {
    Utils,
    Modal,
    SharedSendMessage
  },
  data () {
    return {
      modals: {
        sendMessage: false
      }
    }
  },
  mounted () {
    EventBus.$on('initSendSmsPopup', this.initSendSmsPopup)
  },
  methods: {
    sendSmsModal (number) {
      EventBus.$emit('setGivenNumber', number)
      this.modals.sendMessage = true
    },
    initSendSmsPopup (number) {
      Utils.openPopUp(this.$store.getters.ctiPopUp, 'send-sms', { number }, this.sendSmsModal)
    }
  }
}
</script>
